import { Box, Button, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useEffect } from "react";
import { Block } from "notiflix";
import MeetingItems from "./MeetingItems";
import { isEmpty } from "underscore";
import { makeRequest } from "../util/AxiosInstance";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

function BookingCard() {
    const navigate = useNavigate();

    // React Query fetch function
    const fetchBookings = async () => {
        const res = await makeRequest('GET', `/bookings?perPage=4&status=upcoming`);
        let data = res.data?.data?.data || [];
        console.log(data);
        
        return data;
    };

    // React Query hook
    const {
        data: bookings = [],
        isLoading,
        isFetching,
    } = useQuery({
        queryKey: ['bookings', { perPage: 4, status: 'upcoming' }],
        queryFn: fetchBookings,
        keepPreviousData: true,
        refetchOnWindowFocus: true, // default, but explicit
    });

    useEffect(() => {
        let el = document.querySelector('.booking-list');
        if (isLoading || isFetching) {
            if (el) Block.circle('.booking-list');
        } else {
            if (el) Block.remove('.booking-list');
        }
    }, [isLoading, isFetching]);

    return (
        <Box component={motion.div}
            sx={{
                height: {
                    lg: '100%',
                    xs: 'auto'
                },
                minHeight: {
                    lg: '100%',
                    xs: '300px'
                }
            }}
            className="card-item bookings">
            <div className="card-item-header">
                <Typography variant="h6">
                    Bookings
                </Typography>
                <Button
                    onClick={() => {
                        navigate('/bookings');
                    }}
                    disabled={isEmpty(bookings)}
                    color="secondary"
                    variant="text">View All</Button>
            </div>
            <MeetingItems />
        </Box>
    );
}

export default BookingCard;